if (!customElements.get('ke-engraving-offer')) {
  customElements.define('ke-engraving-offer', class extends HTMLElement {
    connectedCallback() {
      this.choice = this.querySelector('.ke-engraving-choice');
      this.checkbox = this.querySelector('.ke-engraving-checkbox');
      if (!this.choice || !this.checkbox) return;
      this.onChange = () => {
        const controls = this.findControls();
        if (!controls) return this.sync();
        (this.checkbox.checked ? controls.withOption : controls.withoutOption).click();
        this.sync();
      };
      this.checkbox.addEventListener('change', this.onChange);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'aria-disabled'] });
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.checkbox?.removeEventListener('change', this.onChange);
      this.source?.classList.remove('ke-engraving-source');
    }
    findControls() {
      const source = this.querySelector('[data-option-id="a71ed9a8-09ac-40ce-bbbd-90c40b5d48af"]');
      if (!source) return null;
      const labels = [...source.querySelectorAll('.po-buttonOption-label')];
      if (labels.length !== 2) return null;
      const find = value => labels.find(el => el.textContent.trim().toLowerCase() === value)?.closest('.po-optionItem-item');
      const withOption = find('with engraving');
      const withoutOption = find('without engraving');
      if (!withOption || !withoutOption) return null;
      return { source, withOption, withoutOption };
    }
    sync() {
      const controls = this.findControls();
      if (!controls) {
        this.choice.hidden = true;
        if (this.source?.classList.contains('ke-engraving-source')) this.source.classList.remove('ke-engraving-source');
        this.source = null;
        return;
      }
      this.source = controls.source;
      const withSelected = Boolean(controls.withOption.querySelector('.po-buttonOption-selected'));
      const withoutSelected = Boolean(controls.withoutOption.querySelector('.po-buttonOption-selected'));
      if (!withSelected && !withoutSelected) {
        this.choice.hidden = true;
        if (this.source.classList.contains('ke-engraving-source')) this.source.classList.remove('ke-engraving-source');
        return;
      }
      this.checkbox.checked = withSelected;
      this.checkbox.disabled = Boolean(controls.withOption.closest('[aria-disabled="true"]'));
      if (!this.source.classList.contains('ke-engraving-source')) this.source.classList.add('ke-engraving-source');
      this.choice.hidden = false;
    }
  });
}

// Keep gift labels aligned without changing the shared app settings.
(() => {
  const labels = new Map([
    ['free shipping', 'Free\nShipping'],
    ['mystery mini katana', 'Mystery Mini\nKatana'],
    ['$10 gift card', '$10\nGift Card'],
    ['free engraving', 'Free\nEngraving']
  ]);
  const init = () => {
    document.querySelectorAll('.ke-product-page .ke-mars-offer').forEach(offer => {
      const format = () => {
        offer.querySelectorAll('.kaching-bundles__progressive-gifts__gift__title').forEach(title => {
          const key = title.textContent.trim().replace(/\s+/g, ' ').toLowerCase();
          const label = labels.get(key);
          if (!label || title.textContent === label) return;
          const text = [...title.childNodes].filter(node => node.nodeType === Node.TEXT_NODE);
          if (text.length === 1) text[0].nodeValue = label;
        });
      };
      format();
      new MutationObserver(format).observe(offer, {childList: true, subtree: true, characterData: true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
